/**
 * Requires
 */

import $ from 'jquery'
window.jQuery = $

/**
 * Modules
 */

import * as Acknowledgment from './acknowledgment'
import * as Maps from './map'
import * as Toggle from './toggle'
import * as SmoothScroll from './smooth-scroll'
import * as VideoEmbed from './video-embed'
import * as ExternalLinks from './external-links'
import * as CalendarNavigation from './calendar-navigation'
import * as Gallery from './gallery'
import * as OverflowShadow from './overflow-shadow'
import * as Favourites from './favourites'
import * as TankAdvertisement from '@bigfishtv/tank-advertisement-tracking'
import * as AjaxForm from './ajax-form'
import * as Analytics from './analytics'
import * as Carousel from './carousel'
import * as ToggleEventView from './toggle-event-view'
import * as SessionSelect from './session-select'
import * as Accordion from './accordion'
import * as EventFooter from './event-footer'
// import * as PetalsTrippin from './petals-test'
// import * as PetalsBrand from './petals-brand'
import * as Slider from './slider'
import * as Modal from './modal'
import * as AutoSubmit from './auto-submit'
import * as HistoryPushState from './history-push-state'
import * as EventOrder from './event-order'
import * as Parallax from './parallax'
import * as PresaleToken from './presale-token'
import * as Header from './header'

import { trackEvent } from './utils/analytics'

/**
 * Initialisation
 */

Maps.initialize()
Toggle.initialise()
SmoothScroll.initialise()
VideoEmbed.initialise()
ExternalLinks.initialise()
CalendarNavigation.initialise()
Gallery.initialise()
OverflowShadow.initialise()
Favourites.initialise()
TankAdvertisement.initialise()
Acknowledgment.initialise()
AjaxForm.initialise()
Analytics.initialise()
Carousel.initialise()
ToggleEventView.initialise()
SessionSelect.initialise()
Accordion.initialise()
EventFooter.initialise()
// PetalsTrippin.initialise()
// PetalsBrand.initialise()
Slider.initialise()
Modal.initialise()
AutoSubmit.initialise()
HistoryPushState.initialise()
EventOrder.initialise()
Parallax.initialise()
PresaleToken.initialise()
Header.initialise()

// we use this from cake templates so we need it here
window.trackEvent = trackEvent
